import React from "react";
import { ShieldCheck, Shield, CreditCard, Zap } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "Escrow Protected", testId: "trust-escrow", accent: "text-[#00ff88]" },
  { icon: Shield, label: "Auto Watermark", testId: "trust-watermark", accent: "text-[#ffaa00]" },
  { icon: CreditCard, label: "Card & Crypto", testId: "trust-payments", accent: "text-[#00bbff]" },
  { icon: Zap, label: "Instant Release", testId: "trust-release", accent: "text-[#00ff88]" },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="max-w-7xl mx-auto px-6 py-8">
      <div className="cc-surface rounded-2xl px-6 py-5 grid grid-cols-2 md:grid-cols-4 gap-4">
        {ITEMS.map((t) => {
          const Icon = t.icon;
          return (
            <div key={t.label} data-testid={t.testId} className="flex items-center gap-3 justify-center md:justify-start">
              <span className="w-9 h-9 rounded-lg bg-[#06060c] border border-[#15152a] flex items-center justify-center">
                <Icon size={16} className={t.accent} />
              </span>
              <span className="text-sm text-white">{t.label}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
